module.exports = __webpack_public_path__ + "static/media/como-3.63546393.jpg";